// eslint-disable-next-line import/prefer-default-export
export const RESET = `RESET`;
export const SUBMIT = `SUBMIT`;
export const FETCH = `FETCH`;
export const POPULATE_ONE = `POPULATE_ONE`;
export const DELETE_ONE = `DELETE_ONE`;
export const DEACTIVATE_ONE = `DEACTIVATE_ONE`;
export const DEACTIVATE_MANY = `DEACTIVATE_MANY`;
export const LOGIN = `LOGIN`;
export const LOGOUT = `LOGOUT`;
export const RESET_PASSWORD = `RESET_PASSWORD`;
export const SET_PASSWORD = `SET_PASSWORD`;
export const CHECK_TOKEN = `CHECK_TOKEN`;
export const SEARCH = `SEARCH`;
export const TOGGLE_DRAWER = `TOGGLE_DRAWER`;
export const TOGGLE_USER_DRAWER = `TOGGLE_USER_DRAWER`;
export const ADD_SNACKBAR = `ADD_SNACKBAR`;
export const HIDE_SNACKBAR = `HIDE_SNACKBAR`;
export const RESET_SEARCH = `RESET_SEARCH`;
export const IS_LOGIN_AVAILABLE = `IS_LOGIN_AVAILABLE`;
export const UPLOAD_LOGO = `UPLOAD_LOGO`;
export const UPDATE_ABONNEMENT = `UPDATE_ABONNEMENT`;
export const GENERATE_TOKEN = `GENERATE_TOKEN`;
export const FETCH_USER_AVAILABLE_ACCES = `FETCH_USER_AVAILABLE_ACCES`;

export const LOGIN_GENERAL = `LOGIN_GENERAL`;
export const RESET_PASSWORD_GENERAL = `RESET_PASSWORD_GENERAL`;
export const SET_PASSWORD_GENERAL = `SET_PASSWORD_GENERAL`;
export const CHECK_TOKEN_GENERAL = `CHECK_TOKEN_GENERAL`;
export const LOGOUT_GENERAL = `LOGOUT_GENERAL`;
export const SET_DESTINATION = `SET_DESTINATION`;

export const EXPORTS = `EXPORTS`;
export const NOTIFICATIONS = `NOTIFICATIONS`;
export const VALIDATION = `VALIDATION`;
export const CANCEL_VALIDATION = `CANCEL_VALIDATION`;
export const GET_NOTIFICATION_BADGE = `GET_NOTIFICATION_BADGE`;
